import React from 'react';
import PropTypes from 'prop-types';
import SubstancePubChemReferences from '@Components/Results/substances/details/substance-pubchem-references.component';
import SubstanceAlternativeDetails from '@Components/Results/substances/details/substance-alternative-details.component';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceHeader from '@Components/Results/substances/details/SubstanceHeader';
import SubstanceSupplierData from '@Components/Results/substances/details/substance-supplier-data.component';
import SubstanceFactLinks from '@Components/Results/substances/details/SubstanceFactLinks';
import SubstanceRightHandLinks from '@Components/Results/substances/details/SubstanceRightHandLinks';
import { createE2EClass } from '@Utils/String';
import ShoppingCartTooltipContent from '@Components/Results/structure/availability/ShoppingCartTooltipContent';

import './SubstanceDetailsContainer.scss';
// RX-3549 - remove imports once feature switcher is removed

export default class SubstanceDetailsContainer extends React.PureComponent {
  render() {
    const { metadata, onToggle, substance, database, toggleSuppliers, toggleCommercialSuppliers, toggleIdentification, toggleMoreNames } =
      this.props;
    const { isReaxysContent, isCIDatabase, supportsSupplierData, isPubChem, isCommercialSupplierData } = database;
    const toggleIdentificationFact =
      isReaxysContent || isCIDatabase || isCommercialSupplierData ? () => onToggle('ID', true) : toggleIdentification;

    return (
      <div className="substance-details-container u-els-padding-left">
        <SubstanceHeader metadata={metadata} substance={substance} database={database} onToggle={toggleIdentificationFact} />

        <div className={`substance-details substance-details--${createE2EClass(database.name)}`}>
          <div>
            {isReaxysContent || isCIDatabase || isCommercialSupplierData ? (
              <SubstanceFactLinks substance={substance} onToggle={onToggle} />
            ) : (
              <SubstanceAlternativeDetails
                substance={substance}
                toggleSuppliers={toggleSuppliers}
                toggleCommercialSuppliers={toggleCommercialSuppliers}
                toggleIdentification={toggleIdentification}
                toggleMoreNames={toggleMoreNames}
              />
            )}
          </div>
          {!metadata.heatmapMode && (
            <div className="substance-details-right els-btn-group-vertical">
              <SubstanceRightHandLinks metadata={metadata} substance={substance} />

              {supportsSupplierData && <SubstanceSupplierData supplierData={substance.supplierData} database={database} />}

              {isCommercialSupplierData && (
                <ShoppingCartTooltipContent details={substance.details} className="substance-details-right--rcs-info" />
              )}

              {isPubChem && <SubstancePubChemReferences references={substance.pubchemReferences} />}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SubstanceDetailsContainer.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  toggleSuppliers: PropTypes.func.isRequired,
  toggleIdentification: PropTypes.func.isRequired,
  toggleMoreNames: PropTypes.func.isRequired,
  toggleCommercialSuppliers: PropTypes.func,
};
